import React, { Component } from 'react';

/**
 * Funcion que devuelve un componente que representa la fila
 */
const Row = (props) => {
    const {tipo,proceso} = props;
    let inconoTipo='';

    switch (tipo){
        case "P" :
            inconoTipo= 'icono-gear2'
        break;
        
        case "I" :
            inconoTipo= 'icono-input2'
        break;
        
        case "O" :
            inconoTipo= 'icono-output2'
        break;
    }

    return (
    <tr>
        <td className='EstadoLabel'>
            <div className={inconoTipo}></div>
        </td>
        <td>
            {proceso}
        </td>
        
    </tr>);
};

class ModalProcesosDocumentados extends Component {
    render() {
        
        const {procesos,administradora} = this.props;
        const filas = procesos ? procesos.map(proceso=><Row proceso={proceso.Descripcion} tipo={proceso.TipoProceso}/>) : null;
        let logo='';
        if(filas.length > 0) logo = " image-mastercard-logo procesoLogo"; 
        
        // switch(administradora){
        //     case 1:
        //         logo = " image-visa-logo procesoLogo"
        //     break;
    
        //     case 2:
        //         logo = " image-cabal-logo procesoLogo"
        //     break;
    
        //     case 3:
        //         logo = " image-mastercard-logo procesoLogo"
        //     break;
        // }
        
        return (
            <div className='modalContainer'>
                <div className='modalProcesosOut'>
                   <div className='modalProcesosDocumentadosHeader'>
                       <div className='modalProcesosDocumentadosHeaderText'>
                           Procesos documentados para ejecutarse en la fecha
                       </div>
                        <div className='procesoColumnRight'>
                            <label onClick={()=>this.props.mostrarModal(1,false)} className='ti-close clickable modalProcesosClose closeProcesosDocumentados'></label>
                       </div>
                   </div>
                   <div className='modalProcesosBody modalProcesosInfoContainer procesosDocumentadosScroll'>
                       <table className='tableProcesosDocumentados'>
                           <tr>
                               <th className='EstadoLabel'>
                                   Tipo
                               </th>
                               <th>
                                   <span className={administradora == 3 ? 'relativeTop10':''}>Proceso</span>
                                   <span className={'marcaProcesosDocumentados' + logo}></span>
                               </th>
                           </tr>
                           {filas}
                       </table>
                   </div>
                   <div className='modalProcesosFooter'>
                       <button onClick={()=>this.props.mostrarModal(1,false)} className="btn btn-secondary botonCerrarProcesosDocumentados">Cerrar</button>
                   </div>
                </div>
            </div>
        );
    }
}

export default ModalProcesosDocumentados;